import React from 'react';

import useMemberRequirementsFilterDropdown from './UseMemberRequirementsFilterDropdown';

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const MemberRequirementsFilterDropdown = ({ label, name, value, error, message, onChange }) => {
  const { memberRequirementState } = useMemberRequirementsFilterDropdown();

  return memberRequirementState?.message
    ? <span className={global.LoadingMsg}>{memberRequirementState?.message}</span>
    : (
      <Dropdown
        error={error}
        label={label}
        message={message}
        options={memberRequirementState?.filteredRoleList}
        name={name}
        value={value}
        onChange={onChange}
        isLoading={memberRequirementState?.isArrayLoading}
      />
    );
};

export default MemberRequirementsFilterDropdown;